/* eslint no-console: 0 */
import { createApp } from 'vue'
import BatchApp from '../batch-member-importer/app.vue'
import CsvTemplateApp from '../csv-template/app.vue'
import AsyncCode from '../async-code/app.vue'
import PaymentConfirmer from '../payment/confirmer.js'


document.addEventListener('turbolinks:load', () => {
  if(document.getElementById('async-code')){
    createApp(AsyncCode).mount('#async-code');
  }

  // Stored globally so system tests can unmount it to verify interval cleanup
  // On tests, it's possible to get the value from window._batchMemberImporterApp and call unmount() on it 
  // to verify that the interval is cleared and no more requests are made
  if(document.getElementById('batch-member-importer')){
    window._batchMemberImporterApp = createApp(BatchApp);
    window._batchMemberImporterApp.mount('#batch-member-importer');
  }

  if(document.getElementById('csv-templates')){
    createApp(CsvTemplateApp).mount('#csv-templates');
  }  

  const el = document.getElementById('payment-confirmer');
  if (el) {
    createApp(PaymentConfirmer).mount('#payment-confirmer');
  }
})
